import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { StorageService } from "@app/services/storage.service";
import { Utils } from "@tools";

export interface IThumbFilter {
    (mediaPath: string, width?: number, height?: number): string;
}
// declare module "angular" {
//     interface IFilterService {
//         (name: "thumb"): IThumbFilter;
//     }
// }

@NgFilter({
    token: Token.ThumbFilter,
    dependencies: [
        Token.StorageService
    ]
})
export class ThumbFilter {
    constructor(storageService: StorageService) {
        return ((mediaPath: string, width?: number, height?: number) => {
            let path = mediaPath;

            if (mediaPath) {
                if (!Utils.isAbsoluteUrl(mediaPath)) {
                    // if the consumer is asking for a size bigger than our thumbnails, then we load the full res image
                    if ((width && width > 90) || (height && height > 90)) {
                        path = storageService.getMediaUrl(mediaPath);
                    } else { // size is thumbnail size or lower, so we load the thumbnail for speed
                        path = `${storageService.getMediaUrl(mediaPath)}?width=96&height=96`;
                    }
                }
            }
                
            return path;
        }) as IThumbFilter as any;
    }

}
